export const ApiEndpoints = Object.freeze({
  AUTH_B2B: "/auth/b2b",
  QUOTES: "/quotes",
  TAX: "/tax",
  SETTINGS: "/settings",
  B2B: "/b2b",
  B2B_ORDERS: "/b2b-orders",
  B2B_PREORDERS: "/b2b-preorders",
  PREORDER: "/preorder",
  COMPANIES: "/companies",
  B2B_COMPANIES: "/b2b/companies",
  PORTAL_INVOICES: "/system/b2b/portal/invoices",
  PORTAL_SOA: "/system/b2b/portal/soa",
  B2B_LEDGER: "/b2b/ledger",
  B2B_ADJUSTMENTS: "/b2b/adjustments",
  B2B_PAYMENT_SLIPS: "/b2b/payment-slips",
  NOTIFICATIONS: "/notifications",
  RMA: "/rma",
  STORAGE: "/storage",
  SUPPLIERS: "/suppliers",
  PRODUCTS: "/products",
  CONSIGNMENT: "/consignment",
});
